var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialogCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5762 8.60737C20.9583 3.85365 13.3611 3.74355 8.60738 8.36144C3.85367 12.9793 3.74356 20.5765 8.36146 25.3303C12.9794 30.084 20.5766 30.1941 25.3303 25.5762C30.084 20.9583 30.1941 13.3611 25.5762 8.60737Z",
    className: "bg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5226 11.5738C22.966 12.0302 22.9552 12.7802 22.4987 13.2236L18.6187 16.9928L22.3878 20.8728C22.8313 21.3292 22.8204 22.0792 22.3639 22.5226C21.9075 22.966 21.1575 22.9552 20.7141 22.4987L16.9449 18.6187L13.0649 22.3878C12.6085 22.8313 11.8585 22.8204 11.4151 22.3639C10.9717 21.9075 10.9826 21.1575 11.439 20.7141L15.319 16.9449L11.5499 13.0649C11.1065 12.6085 11.1173 11.8585 11.5738 11.4151C12.0302 10.9717 12.7802 10.9826 13.2236 11.439L16.9928 15.319L20.8728 11.5499C21.3292 11.1065 22.0791 11.1173 22.5226 11.5738Z",
    className: "icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogCloseIcon);
export default __webpack_public_path__ + "static/media/dialog-close-icon.39ffdd13e9438e12e9bc56dc39fcc884.svg";
export { ForwardRef as ReactComponent };